import { render } from "./StoreStatisticDetailTopCards.vue?vue&type=template&id=12402f9c&scoped=true&ts=true"
import script from "./StoreStatisticDetailTopCards.vue?vue&type=script&lang=ts"
export * from "./StoreStatisticDetailTopCards.vue?vue&type=script&lang=ts"

import "./StoreStatisticDetailTopCards.vue?vue&type=style&index=0&id=12402f9c&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\hjp\\yijian-proxy-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12402f9c"]])

export default __exports__